/**
 * Rebuild a select box using a source array and htmlFormatting function for the innerHTML
 * @param {array} sourceArray The source data to use
 * @param {Element} element The select element to rebuild
 * @param {function} htmlFormatter Function to format the HTML used for the <option> innerHTML. Is passed value => {}
 * @param {function} valueFormatter Function to format the value used for the <option> value. Is passed value => {}
 * @param {function} additionalPropertiesHandler Optional function that is passed the value and then the <option> element. Useful for setting a dataset property
 */
export default function(sourceArray, element, htmlFormatter, valueFormatter, additionalPropertiesHandler) {
    const currentlySelectedValue = element.value;
    if (element.options.length > 0) {
        for (let index = element.options.length - 1; index >= 0; index--) {
            element.remove(index);
        }
    }
    if (typeof htmlFormatter == 'undefined') {
        htmlFormatter = value => value;
    }
    if (typeof valueFormatter == 'undefined') {
        valueFormatter = value => value;
    }
    Object.keys(sourceArray).forEach(key => {
        const value = sourceArray[key];
        let opt = document.createElement('option');
        opt.value = valueFormatter(value);
        opt.innerHTML = htmlFormatter(value);
        if (additionalPropertiesHandler) {
            additionalPropertiesHandler(value, opt);
        }
        if (opt.value == currentlySelectedValue) {
            opt.selected = true;
        }
        element.appendChild(opt);
    })
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/finance/finance-types/update-select-from-array.js